module.exports = __webpack_public_path__ + "static/media/avatar13.7c4cf343.jpg";